import React from 'react';
import {GlobalMessagesProvider} from "./src/contexts/GlobalMessagesContext";
import httpApi from "./src/utils/api/HttpApi";

export const wrapRootElement = ({ element }) => {
    httpApi.initialize();

    return (
        <GlobalMessagesProvider>
            {element}
        </GlobalMessagesProvider>
    );
}
